import {observable, computed} from "mobx";
/**
 * Created by icepoint1999 on 29/03/2017.
 */
export  default  class global {
    @observable loading = "test"

}